import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import React, { useCallback, useEffect, useState } from 'react';
const employeeService = {
  useImportStatus(projectElsterDetailId) {
    const [data, setData] = useState([]);
    const [importStatus, setImportStatus] = useState({});
    const [intervalId, setIntervalId] = useState(null);
    const getImportStatus = useErrorHandling(useCallback(async () => {
      const response = await this.get(projectElsterDetailId, 'import_staff_cost_template');
      if (response === null) {
        setImportStatus({
          import_status: 'never_imported'
        });
      } else {
        setImportStatus({
          ...response
        });
      }
      if (response?.import_status !== 'pending') {
        employeeService.useGetStaffCost(setData, projectElsterDetailId);
      }
      return response;
    }, [projectElsterDetailId]));
    const importTemplate = useErrorHandling(useCallback(async body => {
      const response = await this.postFormData(projectElsterDetailId, body);
      setImportStatus({
        ...response
      });
    }, [projectElsterDetailId]));
    useEffect(() => {
      if (importStatus.import_status === 'pending' && !intervalId) {
        const currentId = setInterval(() => {
          getImportStatus();
        }, 2000);
        setIntervalId(currentId);
      } else if (importStatus.import_status !== 'pending' && !!intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
      return () => {
        clearInterval(intervalId);
      };
    }, [getImportStatus, importStatus.import_status, intervalId, projectElsterDetailId]);
    useEffect(() => {
      getImportStatus();
    }, [getImportStatus]);
    return [data, setData, importStatus, importTemplate];
  },
  async useGetStaffCost(setData, projectElsterDetailId) {
    const response = await this.get(projectElsterDetailId, 'staff_costs');
    setData([...response]);
  },
  useExportTemplate(projectElsterDetailId) {
    window.open(`/api/project_elster_details/${projectElsterDetailId}/export_staff_cost_template`);
  },
  get(projectElsterDetailId, subRoute) {
    return generalRouteSubRouteService.getAll(projectElsterDetailId, 'project_elster_details', subRoute);
  },
  postFormData(projectElsterDetailId, body) {
    return generalRouteSubRouteService.postFormData(projectElsterDetailId, 'project_elster_details', 'import_staff_cost_template', body);
  }
};
export default employeeService;